import { ContentApiConfiguration } from "../configuration/content-api-configuration.model";
import { Observable } from 'rxjs/Observable';
import { ClientBase, Core, OvsParameterCodec, QueryParamService } from "../shared/core/ovs.core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Injectable, ElementRef, Output, EventEmitter } from "@angular/core";
import { EnvironmentConfigurationService } from "./environment-configuration.service";

@Injectable()
export class ContentApiClient {
    configuration: ContentApiConfiguration;
    httpClient: HttpClient;
   
    constructor(private qryParamsService: QueryParamService, private configService: EnvironmentConfigurationService){}

    getContent(params: any, success?: (value: string) => void, error?: (error: any) => void): void {
        const requestUrl = `${this.configService.configuration.contentApiConfiguration.rootUrl}/upsellContent/markup?partnerId=${params.partnerId}&memberClassId=${params.memberClassId}&benefits[0].amount=${params.benefitAmount.withCurrentMembership}&benefits[0].memberClassId=${params.memberClassId}&benefits[1].amount=${params.benefitAmount.withUpgradedMembership}&benefits[1].memberClassId=${params.upgradeMemberClassId}&product=resort&locale=en-us`;

        if (!this.httpClient) {
            this.httpClient = Core.current.getRequiredService<HttpClient>(HttpClient);
        }

        let httpParams: HttpParams = new HttpParams({ encoder: new OvsParameterCodec() });

        for(let param in params)
        {
            httpParams = httpParams.append(param, params[param]);
        }

        let headers: HttpHeaders = new HttpHeaders();

        this.httpClient.get(requestUrl, { params: httpParams, headers: headers, observe: "body", responseType:"text", withCredentials: false }).subscribe(
            (value: string) => 
            {
                if (success)
                {
                    success(value);
                    
                }
            },
            error);
    }

 
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/content-service.ts